import { put, takeLatest } from 'redux-saga/effects';

import * as actions from './actions';
import * as api from './api';
import * as constants from './constants';

export function* listRequestSaga(action) {
  const { enrollmentSlug, postCode, productSlug } = action.payload;

  try {
    const response = yield api.list({
      enrollmentSlug,
      productSlug,
      postCode,
    });

    yield put(actions.listSuccess({ productSlug, response: response.data }));
  } catch (error) {
    yield put(actions.listFailure({ productSlug, error }));
  }
}

// Individual exports for testing
export default function* productDetailModalSaga() {
  yield takeLatest(constants.LIST_REQUEST, listRequestSaga);
}
